"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditOff = function EditOff(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    fill: "#000000",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20,0a1.14,1.14,0,0,0-.83.34L17,2.56l4.5,4.5,2.21-2.22a1.18,1.18,0,0,0,0-1.68L20.85.34A1.27,1.27,0,0,0,20,0M1.54,2.41,0,3.94,7.8,11.7l-5.4,5.4v4.5H6.9l5.4-5.4L20.06,24l1.54-1.54L13.8,14.7,9.3,10.2,1.54,2.41M15.67,3.83,10.84,8.67l4.5,4.5,4.83-4.83Z"
  }));
};

var _default = EditOff;
exports["default"] = _default;